import styled from "@emotion/styled";
import {
  Content as SystemContent,
  Modal as SystemModal,
} from "@hundred5/design-system";
import { ReactNode } from "react";

type Color = "default" | "yellow" | "pink" | "violet" | "blue" | "green";

interface Props {
  open: boolean;
  title: string;
  color?: Color;
  content: ReactNode;
  form?: ReactNode;
  buttons: ReactNode;
  illustration?: ReactNode;
  onClose: () => void;
}

export function Modal(props: Props) {
  return (
    <SystemModal open={props.open} onClose={props.onClose} size="small">
      <Illustration
        background={props.color || "default"}
        empty={props.illustration == null}
      >
        {props.illustration}
      </Illustration>
      <Container>
        <Title>{props.title}</Title>
        <Content>{props.content}</Content>
        {props.form ? <Form>{props.form}</Form> : null}
        <Buttons>{props.buttons}</Buttons>
      </Container>
    </SystemModal>
  );
}

const Illustration = styled.div<{ background: Color; empty: boolean }>`
  height: ${(props) => (!props.empty ? "180px" : "6px")};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => illustrationBackgrounds[props.background]};
  border-radius: 3px 3px 0 0;
`;

const illustrationBackgrounds = {
  default: "#FF897A",
  yellow: "#F2C94C",
  pink: "#E994AA",
  violet: "#7474FF",
  blue: "#3599CE",
  green: "#1DC488",
};

const Container = styled.div`
  padding: 40px 20px;
`;

const Title = styled.h2`
  margin: 0 0 10px;
  text-align: center;
  font-size: ${22 / 14}rem;
  color: #1a1a1a;
`;

const Content = styled(SystemContent)`
  text-align: center;
`;

const Form = styled.div`
  margin-top: 15px;
`;

const Buttons = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 10px;
  justify-content: center;
  margin-top: 15px;
`;
